import MarkdownIt from 'markdown-it'
import type { App } from 'vue'

export default (app: App) => {
  const md = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true,
  })

  app.config.globalProperties.$md = md
}
